import React, { useEffect, useMemo } from 'react'
import { Platform } from 'react-native'

type Props = {
  adSlot: string
  adClient?: string
  fullWidthResponsive?: boolean
  format?: 'auto' | 'rectangle' | 'vertical' | 'horizontal'
  style?: React.CSSProperties
  adKey?: string
}

declare global {
  interface Window {
    adsbygoogle?: unknown[]
  }
}

export default function AdSenseBanner({
  adSlot,
  adClient = 'ca-pub-2511123537845418',
  fullWidthResponsive = true,
  format = 'auto',
  style,
  adKey,
}: Props) {
  const isWeb = Platform.OS === 'web'

  const Ins = useMemo(() => (isWeb ? ('ins' as any) : null), [isWeb])

  useEffect(() => {
    if (!isWeb) return
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    const scriptId = 'adsbygoogle-js'
    const existing = document.getElementById(scriptId) as HTMLScriptElement | null
    if (!existing) {
      const script = document.createElement('script')
      script.id = scriptId
      script.async = true
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(adClient)}`
      script.crossOrigin = 'anonymous'
      document.head.appendChild(script)
    }

    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch {
      return
    }
  }, [adClient, adSlot, adKey, isWeb])

  if (!isWeb || !Ins) return null

  return (
    <Ins
      className="adsbygoogle"
      style={{ display: 'block', width: '100%', ...style }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={format}
      data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
    />
  )
}

